<section
  class="mx-auto w-full max-w-[90rem] p-5 md:px-8"
  [class.pt-0]="!selectedOrder"
  [class.pt-5]="!!selectedOrder"
>
  @if (loading) {
    <div class="loading-spinner">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
  } @else if (!selectedOrder) {
    <app-table-page
      [orders]="orders"
      [noOrders]="noOrders"
      (selectOrder)="open($event)"
    ></app-table-page>
  } @else {
    <app-view-order
      [order]="selectedOrder"
      [otherSites]="otherSiteServices"
      (selectOrder)="open($event)"
      (back)="goBack()"
    ></app-view-order>
  }
</section>
